/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Silly_Tough_Millipede_HushInputs */

const fr_silly_tough_millipede_hush = /** @type {(inputs: Silly_Tough_Millipede_HushInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} cours aujourd'hui`)
};

/**

* @param {Silly_Tough_Millipede_HushInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const silly_tough_millipede_hush = /** @type {((inputs: Silly_Tough_Millipede_HushInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Silly_Tough_Millipede_HushInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_silly_tough_millipede_hush(inputs)
});